<template>
  <div>
    <avue-form 
                :option="option"
                v-model="form"
                ref="form">
                <template slot="areaId">
                    <el-select
                            v-model="form.areaId"
                            placeholder="请选择需求区域"
                            ref="addConnectSelect"
                            >
                            <el-option :value="form.areaId" show-all-levels :label="form.areaName">
                                <el-tree
                                    node-key="id"
                                    :data="treeFormAreaData"
                                    :props="treeProps"
                                    :load="editAreaLazyLoadTree"
                                    lazy
                                    @node-click="editAreaNodeTreeClick_"
                                >
                                </el-tree>
                            </el-option>
                    </el-select>
                </template>
                
      <template slot="vehicleType" slot-scope="scope">
                            <el-input
                            :disabled="true"
                                placeholder="车辆类型"
                                v-model="form.carVehicleName">
                            </el-input>
      </template>
                 <template slot="remark">
                        <div>
                            <el-input
                            :disabled="true"
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入内容"
                                v-model="form.remark">
                            </el-input>
                            <remarkModel :remark.sync="form.remark" ref="remarkModel"></remarkModel>
                        </div>
                    </template>
                <template slot="imgAttach">
                    <div>
                        <vupload :disabled="true" :fileList.sync="form.imgAttach"></vupload>
                    </div>
                </template>
                <template slot="endMileage">
                        <el-input :disabled="true" maxlength="10" placeholder="里程数 (千米)" :value="form.endMileage">
                             <el-button slot="append" >千米</el-button>
                        </el-input>
                </template>
                <template slot="evaluate">
                <div style="width:250px;">
                      <!-- <div>{{evaluateInfo.content}}</div> -->
                <!-- <input type="text" placeholder="666666"/> -->
                        <div v-for="(item,index) in evaluateDetailList" :key="index" style="overflow:hidden">

                         <div style="display:inline-block;width:5rem;float:left;"> {{getEvaluateType(item.target)}}:</div>
                            <div style="display:inline-block;float:left;height: 2rem;box-sizing: border-box;padding: .4rem 0;"><el-rate
                              v-model="item.level"
                              disabled
                              text-color="#ff9900"
                              score-template="{value}">
                          </el-rate></div><div style="display:inline-block;float:left;color:#f7ba2a">{{tag(item.level)}}</div>
                        </div>
                </div>
              </template>
                <!-- <template slot="menuForm">
                    <el-button @click="handleClose" ><span class="el-icon-close"></span> 取消</el-button>
                </template> -->
            </avue-form>
  </div>
</template>

<script>
import vupload from "@/views/components/v-upload";
import {getDictionary} from "@/api/crmedical/car/car-record/index";
export default {
  components: {
    vupload,
  },
  props:['form','evaluateDetailList','evaluateTypeList'],
  mounted(){

                    this.getVehicleTypeListFunc().then((_res)=>{
                      this.vehicleTypeList = _res.data;
                    });
  },
  methods:{
    
            getVehicleTypeListFunc(){
                return getDictionary('car_vehicle_type');
            },
            getVehicleTypeName(id){
                let tempName = '';
                this.vehicleTypeList.forEach((ele,index)=>{
                    if(ele.dictKey+'' === id+''){
                        tempName = ele.dictValue;
                    }
                });
                return tempName;
            },
    getEvaluateType(type){
      let name = '';
      this.evaluateTypeList.forEach((ele,index)=>{
        if(ele.dictKey === type){
          name = ele.dictValue;
        }
      });
      return name;
    },
        // 根据评价显示评价等级
        tag(level){
            let tag = '';
            if(level==2){
                tag="差";
            }else if(level==3){
                tag="一般";
            }else if(level==4){
                tag="好";
            }else if(level==5){
                tag="非常好";
            }else if(level==1){
                tag="很差";
            }else if(level==0){
                tag="";
            }
            return tag;
        },
  },
  data(){
    return{
      vehicleTypeList:[],
      option:{
    labelPosition: 'right',
      labelSuffix: '：',
      labelWidth: 120,
      gutter: 0,
      menuBtn: true,
      submitBtn: false,
      submitText: '保存',
      emptyBtn: false,
      emptyText: '清空',
      menuPosition: 'right',
      detail: false,
      tabs: false,
      column: [
        
        {
        disabled:true,
          type: 'input',
          label: '车牌号',
          span: 8,
          display: true,
          prop: 'carNo',
          // formslot:true,
          disabled: true,
          controls: true,
          required: true,
          value:'0',
          placeholder:"车牌号",
          rules: [
            // {
            //   required: true,
            //   message: '请输入本次出车里程',
            //   trigger:'blur'
            // },
            // { type: 'string',trigger: 'change', validator:validateTO2},
            
          ]
        },
        
        {
        disabled:true,
          type: 'input',
          label: '车辆类型',
          span: 8,
          display: true,
          formslot:true,
          prop: 'vehicleType',
          maxlength: 50,
          showWordLimit: true,
          required: true,
                            dicUrl: '/api/blade-system/dict/dictionary?code=car_vehicle_type',
          rules: [
            {
              required: true,
              message: '车辆类型'
            },
            { min: 0, max: 50, message: '请控制在50个字符内！', trigger: 'change' }
          ]
        },
      {
        disabled:true,
        label: "出发时间",
        prop: "startTime",
        type: "datetime",
        format: "yyyy-MM-dd HH:mm:ss",
        valueFormat: "yyyy-MM-dd HH:mm:ss",
        span: 8,
        rules: [
          {
            required: true,
            message: '请选择出发时间'
          },
        ]
      },
      {
        disabled:true,
        label: "结束时间",
        prop: "endTime",
        type: "datetime",
        format: "yyyy-MM-dd HH:mm:ss",
        valueFormat: "yyyy-MM-dd HH:mm:ss",
        span: 8,
        rules: [
          {
            required: true,
            message: '请选择结束时间'
          },
        ]
      },
        {
        disabled:true,
          type: 'input',
          label: '出发地点',
          span: 8,
          display: true,
          formslot:false,
          prop: 'startSite',
          maxlength: 50,
          showWordLimit: true,
          required: true,
          rules: [
            {
              required: true,
              message: '出发地点'
            },
            { min: 0, max: 50, message: '请控制在50个字符内！', trigger: 'change' }
          ]
        },
        {
        disabled:true,
          type: 'input',
          label: '结束地点',
          span: 8,
          display: true,
          formslot:false,
          prop: 'endSite',
          maxlength: 50,
          showWordLimit: true,
          required: true,
          rules: [
            {
              required: true,
              message: '请填写结束地点'
            },
            { min: 0, max: 50, message: '请控制在50个字符内！', trigger: 'change' }
          ]
        },
        
        {
        disabled:true,
          type: 'input',
          label: '司机',
          span: 8,
          display: true,
          prop: 'driverName',
          // formslot:true,
          disabled: true,
          controls: true,
          required: true,
          value:'0',
          placeholder:"司机",
          rules: [
            // {
            //   required: true,
            //   message: '请输入本次出车里程',
            //   trigger:'blur'
            // },
            // { type: 'string',trigger: 'change', validator:validateTO2},
            
          ]
        },
        {
        disabled:true,
          type: 'textarea',
          label: '备注',
          span: 24,
          display: true,
          formslot:true,
          prop: 'remark',
          rules: [
           
            { min: 0, max: 200, message: '请控制在200个字符内！', trigger: 'change' }
          ]
        },
        
        {
        disabled:true,
          type: 'upload',
          label: '附件',
          span: 24,
          display: true,
          showFileList: true,
          multiple: true,
          limit: 10,
          dataType:'array',
          propsHttp: {},
          canvasOption: {},
          prop: 'imgAttach',
          formslot:true,
          drag: true,
     
        },
        
              {
                label: "评价信息",
                prop: "evaluate",
                formslot:true,
              },
       
      ],
    }
    }
  }
}
</script>

<style>

</style>